"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var assign = require("lodash/assign");
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var asRendition_1 = require("../asRendition");
var setDefaultProps = recompose_1.withProps(function (props) {
    return assign({
        p: [3, 4],
        minHeight: "80vh",
    }, props);
});
var setBgImage = function (bgImage) { return (bgImage ? "url(" + bgImage + ")" : 'none'); };
var Base = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-height: ", ";\n\tbackground-size: cover;\n\tbackground-position: center;\n\tbackground-image: ", ";\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tmin-height: ", ";\n\tbackground-size: cover;\n\tbackground-position: center;\n\tbackground-image: ", ";\n"])), function (props) { return props.minHeight; }, function (props) { return setBgImage(props.backgroundImage); });
exports.default = asRendition_1.default(Base, [setDefaultProps]);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/components/Banner.js
// module id = 435
// module chunks = 2